import { Component } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { assets } from '../../core/constants/assets.const';

@Component({
  selector: 'mindbase-sync-calender',
  standalone: true,
  imports: [MatDialogModule, TranslateModule, MatIconModule],
  templateUrl: './sync-calender.component.html',
  styleUrl: './sync-calender.component.scss'
})
export class SyncCalenderComponent {
  assetsConst = assets;
}
